import policiesHero from "../images/Contact_Header_BG.jpg"
import classes from "../components/HeroSection/HeroSection.module.css"
import indexBlackText from "../images/black-text-section.jpg"
import policiesParallax from "../images/HomePage_Parallax.jpg"

export const policiesContent = {
  heroSection: {
    sectionId: "Policies",
    background: policiesHero,
    heroImageClass: "headerImageClass",
    imageFile: "cow.png",
    alt: "cow",
    headerText: "POLICIES",
    displayText: "OUR COMMITMENT TO TRANSPARENCY AND CUSTOMER SERVICE",
    bottomImage: "Contact_Burger.png",
    bottomImageClass: classes.contactImageWrapper,
  },
  refundPolicy: {
    sectionId: "refund-policy",
    background: indexBlackText,
    displayText: [
      {
        text: "REFUND POLICY",
        color: "rgba(255, 255, 255, 1)",
        isTitle: true,
      },
      {
        text:
          "Refunds can be requested via email to Tenetbeef@gmail.com. Refunds can be requested up until samples are sent to our lab for testing. Once samples have been processed and sent to our laboratory, refunds cannot be issued as the testing process has begun. If unacceptable tissue sampling tubes are used, the samples will be returned, and testing payment will be refunded minus a processing fee.",
        color: "rgba(255, 255, 255, 1)",
      },
    ],
  },
  deliveryPolicy: {
    sectionId: "delivery-policy",
    background: indexBlackText,
    displayText: [
      {
        text: "DELIVERIES & SHIPPING POLICIES",
        color: "rgba(255, 255, 255, 1)",
        isTitle: true,
      },
      {
        text: "DELIVERY METHODS & REGIONS:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text: "• Card orders within the USA are shipped via USPS",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• Card orders outside the US are shipped using DHL or USPS",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• We currently service the USA, Canada, Mexico and Australia",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• Our goal is to service worldwide",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "SHIPPING COSTS & TIMES:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text: "• Shipping cost per card order is $12 US & $30 International",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• Standard shipping times apply based on destination",
        color: "rgba(255, 255, 255, 1)",
      },
    ],
  },
  returnPolicy: {
    sectionId: "return-policy",
    background: indexBlackText,
    displayText: [
      {
        text: "RETURN POLICY",
        color: "rgba(255, 255, 255, 1)",
        isTitle: true,
      },
      {
        text:
          "We do not accept returns on our products. All sales are final. If you have concerns about your order, please contact us at Tenetbeef@gmail.com and we will work with you to resolve any issues.",
        color: "rgba(255, 255, 255, 1)",
      },
    ],
  },
  cancellationPolicy: {
    sectionId: "cancellation-policy",
    background: indexBlackText,
    displayText: [
      {
        text: "CANCELLATION POLICY",
        color: "rgba(255, 255, 255, 1)",
        isTitle: true,
      },
      {
        text:
          "We do not currently offer pre-orders, reservations, or subscriptions. All orders are processed immediately upon receipt. If you need to cancel an order, please contact us immediately at Tenetbeef@gmail.com.",
        color: "rgba(255, 255, 255, 1)",
      },
    ],
  },
  privacyPolicy: {
    sectionId: "privacy-policy",
    background: indexBlackText,
    displayText: [
      {
        text: "PRIVACY POLICY",
        color: "rgba(255, 255, 255, 1)",
        isTitle: true,
      },
      {
        text: "DATA COLLECTION:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text:
          "We collect rancher information for sampling their cattle for Tenet® certification. We also collect each animal's ID to test and verify if their animal is Certified Tenet®. Information collected includes:",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• Rancher Information: Name, address, email and phone number",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "• Cattle Information: Cattle ID, breed, and sex",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "DATA USAGE:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text:
          "Cattle information is used to identify specific animal traits and verify certification status. This data helps us maintain the integrity of our Tenet® certification program.",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "DATA SHARING:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text:
          "Information is not shared outside Callipyge Genetics. We maintain strict confidentiality of all rancher and cattle data.",
        color: "rgba(255, 255, 255, 1)",
      },
      {
        text: "DATA PROTECTION:",
        color: "rgba(255, 255, 255, 1)",
        isSubtitle: true,
      },
      {
        text:
          "Each ranch has a dedicated spreadsheet with their cattle's information that is stored securely via a hard drive on a computer. We implement appropriate security measures to protect your personal and cattle information.",
        color: "rgba(255, 255, 255, 1)",
      },
    ],
  },
  parallax: {
    sectionId: "policies-parallax",
    background: policiesParallax,
    alt: "parallax-policies-image",
  },
}
